import { store } from 'redux/store'

import { CardType } from 'types/deck'

export type Column = 'name' | 'action' | 'categories' | 'timestamp'
export type Direction = 'asc' | 'desc'

const ADDED_VALUE = 'Added'
const REMOVED_VALUE = 'Removed'
const MAYBEED_VALUE = 'Not Included'

export function sortAddRemove(cards: CardType[], direction: Direction, column: Column): CardType[] {
  const categories = store.getState().deck.categories

  const data = cards.sort((a, b) => {
    const aIncludedInDeck = categories[a.categories[0]]?.includedInDeck || false
    const bIncludedInDeck = categories[b.categories[0]]?.includedInDeck || false

    if (column === 'categories' && direction === 'asc') return `${a.categories}` > `${b.categories}` ? 1 : -1
    if (column === 'categories' && direction === 'desc') return `${a.categories}` < `${b.categories}` ? 1 : -1

    if (column === 'name' && direction === 'asc') return a.name > b.name ? 1 : -1
    if (column === 'name' && direction === 'desc') return a.name < b.name ? 1 : -1

    // Action ordering needs to take whether a card is included in a deck or not into account
    // If neither card is deleted, then check the categories
    if (column === 'action' && direction === 'asc') {
      if (!a.deletedAt && !b.deletedAt) return aIncludedInDeck < bIncludedInDeck ? 1 : -1
      return !a.deletedAt < !b.deletedAt ? 1 : -1
    }
    if (column === 'action' && direction === 'desc') {
      if (!a.deletedAt && !b.deletedAt) return aIncludedInDeck > bIncludedInDeck ? 1 : -1
      return !a.deletedAt > !b.deletedAt ? 1 : -1
    }

    if (column === 'timestamp' && direction === 'asc')
      return new Date(a.deletedAt || a.createdAt || '') > new Date(b.deletedAt || b.createdAt || '') ? 1 : -1

    return new Date(a.deletedAt || a.createdAt || '') < new Date(b.deletedAt || b.createdAt || '') ? 1 : -1
  })

  return data
}

export function generateFilterOptions(cards: CardType[], column: Column): string[] {
  const categories = store.getState().deck.categories

  const options = cards.reduce((acc, card) => {
    if (column === 'name') acc.push(card.name)

    if (column === 'categories') {
      for (const category of card.categories) {
        if (!acc.includes(category)) acc.push(category)
      }
    }

    if (column === 'action') {
      const isDeleted = !!card.deletedAt
      const includedInDeck = categories[card.categories[0]]?.includedInDeck || false

      if (isDeleted) acc.push(REMOVED_VALUE)
      if (!isDeleted && !includedInDeck) acc.push(MAYBEED_VALUE)
      if (!isDeleted && includedInDeck) acc.push(ADDED_VALUE)
    }

    return acc
  }, new Array<string>())

  return [...new Set(options)]
}

export function filterAddRemoveCards(cards: CardType[], filterBy: Column, filters: string[]): CardType[] {
  const categories = store.getState().deck.categories

  const filteredCards = cards.filter(card => {
    if (filterBy === 'name' && filters.includes(card.name)) return true

    if (filterBy === 'categories') {
      for (const category of card.categories) {
        if (filters.includes(category)) return true
      }
    }

    if (filterBy === 'action') {
      const isDeleted = !!card.deletedAt
      const includedInDeck = categories[card.categories[0]]?.includedInDeck || false

      if (isDeleted && filters.includes(REMOVED_VALUE)) return true
      if (!isDeleted && !includedInDeck && filters.includes(MAYBEED_VALUE)) return true
      if (!isDeleted && includedInDeck && filters.includes(ADDED_VALUE)) return true
    }

    return false
  })

  return filteredCards
}
